import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import MedHourForm from './MedHourForm';

const EditMedHourModal = ({ show, onHide, medhourvalue, edittrigger, onCallParent }) => {
    const isEdit = medhourvalue && (medhourvalue.hour_id || medhourvalue.id);

    const handleSuccess = () => {
        if (onCallParent) onCallParent();
        if (onHide) onHide();
    };

    return (
        <Modal show={show} onHide={onHide} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title as="h5">
                    {isEdit ? 'Edit Hour/HOA' : 'Add Hour/HOA'}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-4">
                <MedHourForm
                    edittrigger={edittrigger}
                    onCallParent={handleSuccess}
                    medhourvalue={medhourvalue}
                />
            </Modal.Body>
        </Modal>
    );
};

EditMedHourModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    medhourvalue: PropTypes.any,
    edittrigger: PropTypes.number,
    onCallParent: PropTypes.func
};

export default EditMedHourModal;

